"use client"

import { useState } from "react"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../UI/select"

/*
const accommodationData = [
  { name: "Posta Don Dionicio", reservas: 45, ingresos: 22500, periodo: "Dic-Ene" },
  { name: "Casa de Campo Serrana", reservas: 38, ingresos: 19000, periodo: "Jul-Ago" },
  { name: "Departamento Vista al Lago", reservas: 32, ingresos: 14400, periodo: "Ene-Feb" },
  { name: "Lodge de Montaña", reservas: 28, ingresos: 33600, periodo: "Dic-Ene" },
  { name: "Cabaña Familiar", reservas: 25, ingresos: 15000, periodo: "Jul-Ago" },
]

const seasonalData = [
  { season: "Verano", reservas: 156, color: "#FF6B6B" },
  { season: "Otoño", reservas: 89, color: "#4ECDC4" },
  { season: "Invierno", reservas: 67, color: "#45B7D1" },
  { season: "Primavera", reservas: 112, color: "#96CEB4" },
]*/

export default function SimpleBookingsPeriodChart({
  accommodationData,
  seasonalData
}: any) {
  const [chartType, setChartType] = useState("accommodations")

  const maxReservas = Math.max(...accommodationData.map((item : any) => item.reservas))
  const totalReservas = seasonalData.reduce((sum : any, item : any) => sum + item.reservas, 0)

  return (
    <div className="bg-white p-6 rounded-lg border shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold">Períodos de Mayor Demanda</h3>
        <Select value={chartType} onValueChange={setChartType}>
          <SelectTrigger className="w-[160px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="accommodations">Por Alojamiento</SelectItem>
            <SelectItem value="seasonal">Por Temporada</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {chartType === "accommodations" ? (
        <div className="space-y-4">
          {accommodationData.map((item : any, index : any) => (
            <div key={index} className="space-y-1">
              <div className="flex justify-between text-sm">
                <span className="font-medium truncate max-w-[180px]">{item.name}</span>
                <span className="text-gray-600">{item.reservas} reservas</span>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-2.5">
                <div
                  className="bg-[#8B9456] h-2.5 rounded-full"
                  style={{ width: `${(item.reservas / maxReservas) * 100}%` }}
                ></div>
              </div>
              <div className="text-xs text-gray-500">Período de mayor demanda: {item.periodo}</div>
            </div>
          ))}
        </div>
      ) : (
        <div>
          <div className="flex justify-center mb-6">
            <div className="relative w-48 h-48">
              {/* Simple Pie Chart */}
              {seasonalData.map((item : any, index : any, arr : any) => {
                // Calculate the start and end angles for each segment
                const total = arr.reduce((sum : any, i : any) => sum + i.reservas, 0)
                const startAngle = arr.slice(0, index).reduce((sum : any, i : any) => sum + (i.reservas / total) * 360, 0)
                const endAngle = startAngle + (item.reservas / total) * 360

                return (
                  <div
                    key={index}
                    className="absolute inset-0"
                    style={{
                      background: `conic-gradient(transparent ${startAngle}deg, ${item.color} ${startAngle}deg, ${item.color} ${endAngle}deg, transparent ${endAngle}deg)`,
                      borderRadius: "50%",
                    }}
                  />
                )
              })}
              <div className="absolute inset-[15%] bg-white rounded-full flex items-center justify-center">
                <span className="text-sm font-medium">{totalReservas} reservas</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {seasonalData.map((season : any, index : any) => (
              <div key={index} className="text-center">
                <div className="w-4 h-4 rounded-full mx-auto mb-1" style={{ backgroundColor: season.color }}></div>
                <div className="text-xs text-gray-600">{season.season}</div>
                <div className="text-sm font-medium">{season.reservas}</div>
                <div className="text-xs text-gray-500">{Math.round((season.reservas / totalReservas) * 100)}%</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
